module.exports = __webpack_public_path__ + "img/slccj.682b0dfd.png";